import type { StageColour } from '@playerbase/types';

import { STAGE_BADGE_CLASSES } from '../../games/stage-colour-classes.js';
import type { BuildStageSummary } from '../../games/playtest-sessions-data.js';

interface Props {
  stage: BuildStageSummary;
}

const FALLBACK: keyof typeof STAGE_BADGE_CLASSES = 'gray';

// Inline pill that mirrors the dev-stage colouring used elsewhere in
// the portal (build markers list, marker pickers). Colour comes from
// game_dev_stages.colour and falls back to gray when the value is null
// or not one of the known palette keys.
export function StageBadge({ stage }: Props): JSX.Element {
  const key = isKnownColour(stage.colour) ? stage.colour : FALLBACK;
  const classes = STAGE_BADGE_CLASSES[key];
  return (
    <span
      className={`rounded-sm border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${classes}`}
    >
      {stage.label}
    </span>
  );
}

function isKnownColour(value: string | null): value is StageColour {
  return value !== null && value in STAGE_BADGE_CLASSES;
}
